import {
  InfiniteScrollDataTable,
  DataTableSearch,
  Typography,
  Loading,
  Button,
} from '@ui/components';
import { DynamicFilters } from '@shared/components/opensearch';
import { Filters, Refresh } from '@ui/components/icons';
import { Trans } from 'react-i18next';
import { useState } from 'react';
import { t } from 'i18next';

import { useTransactionHistoryTable } from './use-transaction-history-table';

interface TransactionHistoryTableProps {
  dateFrom?: Date;
  dateTo?: Date;
}

export const TransactionHistoryTable = (props: TransactionHistoryTableProps) => {
  const { dateFrom, dateTo } = props;

  const [filtersVisible, setFiltersVisible] = useState(false);

  const {
    isTableConfigLoading,
    dynamicFiltersData,
    columnsLength,
    globalFilter,
    hasNextPage,
    isFetching,
    isLoading,
    table,
    fetchNextPage,
    resetTable,
  } = useTransactionHistoryTable({ dateFrom, dateTo });

  const showFilters = !!dynamicFiltersData.filters && filtersVisible;

  return (
    <div className="bg-table-background rounded-lg overflow-hidden mb-8 flex flex-col">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('FILES_REPORTS.TRANSACTION_HISTORY.TABLE_TITLE')}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('FILES_REPORTS.TRANSACTION_HISTORY.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />
          <Button onClick={() => setFiltersVisible((prev) => !prev)} variant="ghost">
            <Filters />
            {t('FILES_REPORTS.TRANSACTION_HISTORY.TABLE_FILTERS')}
          </Button>
          <Button
            onClick={() => resetTable()}
            isLoading={isLoading}
            disabled={isLoading}
            variant="tertiary"
            className="w-50"
            icon
            wide
          >
            <Refresh />
            {t('FILES_REPORTS.TRANSACTION_HISTORY.TABLE_REFRESH')}
          </Button>
        </div>
      </div>

      {showFilters && (
        <DynamicFilters onClear={dynamicFiltersData.clearFilters} {...dynamicFiltersData} />
      )}

      <Loading isLoading={isTableConfigLoading}>
        <InfiniteScrollDataTable
          noResultsComponent={
            <Typography variant="labelMediumBook">
              <Trans i18nKey="FILES_REPORTS.TRANSACTION_HISTORY.TABLE_NO_RESULTS" />
            </Typography>
          }
          fetchNextPage={() => {
            fetchNextPage();
          }}
          columnsLength={columnsLength}
          className="flex-1 h-full"
          isFetching={isFetching}
          hasMore={hasNextPage}
          isLoading={isLoading}
          table={table}
        />
      </Loading>
    </div>
  );
};
